<script setup lang="ts">
import type { BlokDefinitionListEntry } from "@/.storyblok/types/120421/storyblok-components";
import { backgroundColorInjectKey } from "../helpers/injectKeys";

defineProps<{
    blok: BlokDefinitionListEntry;
}>();

const injectedBackgroundColor = inject(backgroundColorInjectKey) as BackgroundColorKey;
</script>

<template>
    <div v-editable="blok" :class="[
        {'bg-brandLight/90 p-4 rounded-xl': injectedBackgroundColor === 'dark'},
        {'bg-brandDark/50 p-4 rounded-xl': injectedBackgroundColor !== 'dark'}
    ]">
        <dt class="font-optimus font-normal text-2xl">{{blok.title}}</dt>
        <dd>{{ blok.value }}</dd>
    </div>
</template>